import React, { useState, useEffect } from "react";
import { adminApi } from "../../backend_urls/adminApi";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";
import DynamicTable from "../../components/reusable/DynamicTable";
import BaseIcon from "../../components/svg_icons/BaseIcon";

const AdminUsersPage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({ email: "", password: "", role: "", user_full_name: "", contact: "" });

    const fetchUsersData = async () => {
        try {
            const response = await adminApi.getAllUsers();
            setData(response.data);
        } catch (error) {
            console.error("Error fetching users:", error);
            // You might want to show an error message to the user here
        } finally { setLoading(false); };
    };
    useEffect(() => { fetchUsersData(); }, []);

    const createNewUser = () => { setShowForm(true); };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            await adminApi.createUser(formData);
            setShowForm(false);
            setFormData({ email: "", password: "", role: "", user_full_name: "", contact: "" });
            fetchUsersData();
        } catch (error) { console.error("Error creating user:", error);
        } finally { setLoading(false); }
    };

    const columns = [
        { key: "__sn", label: "Sr. No.", sortable: false },
        { key: "user_full_name", label: "User Name", sortable: false },
        { key: "email", label: "Email", sortable: false },
        { key: "role", label: "User Type", sortable: false },
        { key: "contact", label: "Contact", sortable: false },
    ];

    const actions = [
        {
            icon: <BaseIcon name="eyeOpen" size={20} />,
            title: "View",
            onClick: (row) => console.log("View", row),
        },
        {
            icon: <BaseIcon name="trash" size={20} />,
            title: "Delete",
            className: "delete",
            onClick: (row) => console.log("Delete", row),
        },
    ];

    return ( loading ? <LoadingSpinner /> : (
        <>
            <h1>This is Admin Users Page</h1>

            <button onClick={createNewUser}>Create New User</button>
            {showForm && (
                <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
                    <input
                        type="email" name="email" placeholder="Email ID"
                        value={formData.email} onChange={handleChange}
                        required
                    />
                    <input
                        type="password" name="password" placeholder="Password"
                        value={formData.password} onChange={handleChange}
                        required
                    />
                    <input
                        type="text" name="role" placeholder="Role"
                        value={formData.role} onChange={handleChange}
                        required
                    />
                    <input
                        type="text" name="user_full_name" placeholder="Full Name"
                        value={formData.user_full_name} onChange={handleChange}
                        required
                    />
                    <input
                        type="text" name="contact" placeholder="Contact"
                        value={formData.contact} onChange={handleChange}
                        required
                    />

                    <button type="submit">Submit</button>
                    <button type="button" onClick={() => setShowForm(false)}>
                        Cancel
                    </button>
                </form>
            )}

            <DynamicTable
                columns={columns}
                data={data}
                itemsPerPage={10}
                onAction={actions}
            />
        </>
    ));
};

export default AdminUsersPage;
